import { render, staticRenderFns } from "./SideScrollBeatTimeline.vue?vue&type=template&id=2b5f2e3a&"
import script from "./SideScrollBeatTimeline.vue?vue&type=script&lang=js&"
export * from "./SideScrollBeatTimeline.vue?vue&type=script&lang=js&"
import style0 from "./SideScrollBeatTimeline.vue?vue&type=style&index=0&id=2b5f2e3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports